/**
 * @generated SignedSource<<678e9aa010b7b96197ad4bef1e9c914e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConnectContactFormFieldConfig = "DISABLED" | "OPTIONAL" | "REQUIRED";
export type ConnectInboxAudience = "CUSTOMERS" | "EMPLOYEES";
export type TodoCategoryIcon = "Check" | "Message" | "Order" | "Sun";
export type ConnectAdminInboxQuery$variables = {
  id: string;
};
export type ConnectAdminInboxQuery$data = {
  readonly connectInbox: {
    readonly audience: ConnectInboxAudience | null;
    readonly contactFormEmail: ConnectContactFormFieldConfig;
    readonly contactFormName: ConnectContactFormFieldConfig;
    readonly contactFormPhone: ConnectContactFormFieldConfig;
    readonly contactFormPrompt: string | null;
    readonly customTitle: string | null;
    readonly description: string | null;
    readonly id: string;
    readonly publicQRCode: {
      readonly svg: string | null;
    };
    readonly publicUrl: string;
    readonly successMessage: string | null;
    readonly tags: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly teams: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly todoCategory: {
      readonly id: string;
    } | null;
    readonly welcomeMessage: string | null;
  };
  readonly store: {
    readonly id: string;
    readonly publicTeams: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"DialogButtonTeams_teams" | "TeamSelectList_Team">;
    }>;
    readonly todoCategories: ReadonlyArray<{
      readonly icon: TodoCategoryIcon | null;
      readonly id: string;
      readonly tags: ReadonlyArray<{
        readonly color: string;
        readonly id: string;
        readonly title: string;
        readonly " $fragmentSpreads": FragmentRefs<"TodoToolbarButtonTags_tags">;
      }>;
      readonly title: string;
    }>;
  };
};
export type ConnectAdminInboxQuery = {
  response: ConnectAdminInboxQuery$data;
  variables: ConnectAdminInboxQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "includeDefault",
    "value": true
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v7 = [
  (v1/*: any*/)
],
v8 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ],
  "concreteType": "ConnectInbox",
  "kind": "LinkedField",
  "name": "connectInbox",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "audience",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategoryTag",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategory",
      "kind": "LinkedField",
      "name": "todoCategory",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "welcomeMessage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "successMessage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publicUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QRCode",
      "kind": "LinkedField",
      "name": "publicQRCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "svg",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contactFormName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contactFormEmail",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contactFormPhone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contactFormPrompt",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConnectAdminInboxQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamSelectList_Team"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "DialogButtonTeams_teams"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "TodoCategory",
            "kind": "LinkedField",
            "name": "todoCategories",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoCategoryTag",
                "kind": "LinkedField",
                "name": "tags",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v4/*: any*/),
                  (v6/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TodoToolbarButtonTags_tags"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "todoCategories(includeDefault:true)"
          }
        ],
        "storageKey": null
      },
      {
        "kind": "RequiredField",
        "field": (v8/*: any*/),
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConnectAdminInboxQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              },
              (v6/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "TodoCategory",
            "kind": "LinkedField",
            "name": "todoCategories",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoCategoryTag",
                "kind": "LinkedField",
                "name": "tags",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v4/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "todoCategories(includeDefault:true)"
          }
        ],
        "storageKey": null
      },
      (v8/*: any*/)
    ]
  },
  "params": {
    "cacheID": "1424c28afdf6623d706725f0a8fd419e",
    "id": null,
    "metadata": {},
    "name": "ConnectAdminInboxQuery",
    "operationKind": "query",
    "text": "query ConnectAdminInboxQuery(\n  $id: ID!\n) {\n  store {\n    id\n    publicTeams {\n      id\n      name\n      ...TeamSelectList_Team\n      ...DialogButtonTeams_teams\n    }\n    todoCategories(includeDefault: true) {\n      id\n      title\n      icon\n      tags {\n        id\n        title\n        color\n        ...TodoToolbarButtonTags_tags\n      }\n    }\n  }\n  connectInbox(id: $id) {\n    id\n    audience\n    teams {\n      id\n    }\n    tags {\n      id\n    }\n    todoCategory {\n      id\n    }\n    welcomeMessage\n    customTitle\n    description\n    successMessage\n    publicUrl\n    publicQRCode {\n      svg\n    }\n    contactFormName\n    contactFormEmail\n    contactFormPhone\n    contactFormPrompt\n  }\n}\n\nfragment AHTeamIcon on Team {\n  icon\n}\n\nfragment AHTeamIconCircle on Team {\n  color\n  ...AHTeamIcon\n  isPrivate\n}\n\nfragment DialogButtonTeamsDetail_team on Team {\n  id\n  ...AHTeamIconCircle\n}\n\nfragment DialogButtonTeams_teams on Team {\n  id\n  name\n  ...DialogButtonTeamsDetail_team\n}\n\nfragment TeamIconCircleComponent_Team on Team {\n  color\n  icon\n  isPrivate\n}\n\nfragment TeamSelectListItem_Team on Team {\n  id\n  name\n  ...TeamIconCircleComponent_Team\n}\n\nfragment TeamSelectList_Team on Team {\n  id\n  name\n  isPrivate\n  ...TeamSelectListItem_Team\n}\n\nfragment TodoTagButtonContentActive_todoCategoryTag on TodoCategoryTag {\n  id\n  title\n  color\n}\n\nfragment TodoToolbarButtonTags_tags on TodoCategoryTag {\n  ...TodoTagButtonContentActive_todoCategoryTag\n}\n"
  }
};
})();

(node as any).hash = "7e07b37bfcea7290ad0994448a6ab115";

export default node;
